import { overlaps } from './moment';

export const getSchedule = (start, end, schedules) => {
  return schedules.find((schedule) => {
    const isIn = overlaps([start, end], [schedule.start, schedule.end]);
    return isIn;
  });
}